<template>
    <v-tooltip
        v-if="showButtonTooltip"
        :text="tooltipText"
        location="top"
        content-class="custom-tooltip"
    >
        <template #activator="{ props }">
            <button
                v-bind="props"
                :class="btnStyle"
                @click="executeMethod"
                :disabled="disabled"
                :data-cy="dataCy"
            >
                <img role="img" :src="iconSrc" />
            </button>
        </template>
    </v-tooltip>

    <button
        v-else
        :class="btnStyle"
        @click="executeMethod"
        :disabled="disabled"
        :data-cy="dataCy"
    >
        <img role="img" :src="iconSrc" />
    </button>
</template>

<script setup lang="ts">
import { computed } from "vue";

const componentProps = defineProps<{
    btnStyle?: string;
    disabled?: boolean;
    iconSrc?: any; // TODO add behaviour
    showTooltip?: boolean;
    tooltipMessage?: string;
    dataCy?: string;
}>();

const showButtonTooltip = computed(() => componentProps.showTooltip ?? false);
const tooltipText = computed(
    () =>
        componentProps.tooltipMessage ??
        "You do not have permission to perform this action.",
);

const emit = defineEmits(["runMethod"]);
const executeMethod = () => {
    emit("runMethod");
};
</script>
